// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"084b19fb","165":"6fc876d4","370":"2763cdd8","435":"428cbd1f","551":"82d16ffb","641":"31fe3246","710":"a21089c4"}[chunkId] + ".chunk.js";
};